import Helpers from "./Helpers.js";
const RightTimeApi = {
  _authRedirectInProgress: false,

  clearAuthSession() {
    window.sessionStorage.removeItem("BearerToken");
    window.sessionStorage.removeItem("User");
  },

  redirectToLoginIfUnauthorized(response) {
    if (!response || response.status !== 401) return;

    const token = window.sessionStorage.getItem("BearerToken");
    if (!token || token.length <= 20) return;
    if (this._authRedirectInProgress) return;

    this._authRedirectInProgress = true;
    this.clearAuthSession();
    window.sessionStorage.setItem("AUTH_SESSION_EXPIRED", "true");

    if (window.location.pathname !== "/") {
      window.location.assign("/");
    }
  },

  async getAsync(url, data, config) {
    return await this.fetchAsync("GET", url, data, config);
  },

  async putAsync(url, data, config) {
    return await this.fetchAsync("PUT", url, data, config);
  },

  async putFormAsync(url, data) {
    return await this.fetchAsync("PUT", url, data, { "Content-Type": "form-data" });
  },

  async patchAsync(url, data) {
    return await this.fetchAsync("PATCH", url, data);
  },

  async postAsync(url, data) {
    return await this.fetchAsync("POST", url, data);
  },

  async deleteAsync(url, data) {
    return await this.fetchAsync("DELETE", url, data);
  },
  async sendAsync(url, data) {
    if (!data.id || data.id <= 0) return this.fetchAsync("POST", url, data);
    else return await this.fetchAsync("PUT", url, data);
  },

  async postFileAsync(url, file) {
    var formData = new FormData();
    formData.append("file", file);
    if (file.name) formData.append("fileName", file.name);
    // debugger;
    return await this.fetchAsync("POST", url, formData);
  },

  async versionAsync() {
    let url = this.URL("/version");
    const resp = await this.fetchAsync("GET", url, null, {
      "Content-Type": "text/plain",
    });
    if (resp && resp.ok) {
      return resp.jsonData.version;
    }
  },

  concatenateUrlParts(...parts) {
    var ret = parts
      .map(part => part.replace(/^\/|\/$/g, '')) 
      .filter(part => part) 
      .join('/');
    return ret;
  },

  URL(baseUrl, path, paramsObj) {
    let ApiUrl = Helpers.Env("VITE_API_URL");
    
    let uri = "";
    //console.log(import.meta.env);
    if (baseUrl) {
      if (!baseUrl.startsWith("http://") && !baseUrl.startsWith("https://")) {
        uri = ApiUrl.replace(/\/+$/, "");
        uri += "/" + baseUrl.replace(/^\/+|\/+$/g, "");
      } else uri = baseUrl;
    }
    if (path && path.length > 0) uri = uri + "/" + path.replace(/^\/+|\/+$/g, "");
    if (paramsObj) {
      const queryString = Object.keys(this.paramsObj)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(this.params[key])}`)
        .join("&");
      if (queryString && queryString.length > 0) uri = uri + `?${queryString}`;
    }
    return uri;
  },

  async deleteAsync(url, data, config) {
    return await this.fetchAsync("DELETE", url, data, config);
  },

  async logError(error) {
    const data = { message: btoa(error.toString()) };
    this.fetchAsync("POST", "/UIError", data);
  },

  async fetchAsync(verb, url, data, additionalHeaders, errorHandler) {
    try {
      const headers = {};
      headers["X-Request-Type"] = "API-Call";

      const token = window.sessionStorage.getItem("BearerToken");
      if (token && token.length > 20) headers["Authorization"] = "Bearer " + token;
      else window.sessionStorage.removeItem("BearerToken");
      const origin = window.location.href;
      if (origin) headers["Referer"] = origin;
      if (additionalHeaders) {
        Object.entries(additionalHeaders).forEach(([key, value]) => {
          headers[key] = value;
        });
      }
      let init = {
        method: verb,
        headers: headers,
      };
      if (data) {
        if (data instanceof FormData) {
          init.body = data;
          // Do not set Content-Type header manually for FormData
        } else {
          init.body = JSON.stringify(data);
          init.headers["Content-Type"] = "application/json";
        }
      }
      url = this.URL(url);
      console.log(["fetch", verb, url, init]);
      const response = await fetch(url, init);

      if (response.ok) {
        const refreshedToken =
          response.headers.get("X-Refreshed-Token") ||
          response.headers.get("X-Refrehed-Token");
        if (refreshedToken && refreshedToken.length > 20)
          window.sessionStorage.setItem("BearerToken", refreshedToken);
      }

      const contentType = response.headers.get("Content-Type");

      if (contentType && contentType.includes("application/json")) 
        response.jsonData = await response.json();

      this.redirectToLoginIfUnauthorized(response);

      if (!response.ok) {
        if (errorHandler) {
          errorHandler(response);
        } else {
          if (response.status !== 401 && !url.includes("UIError"))
            this.logError(
              "Error calling [" + verb + "] " + url + " StatusCode:" + response.status + " " + response.statusText
            );
          console.log(["Error calling", verb, url, "StatusCode:" + response.status, response.statusCode]);
        }
      }
      return response;
    } catch (error) {
      if (!url.includes("UIError")) this.logError("Exception calling [" + verb + "] " + url + " " + error);
      console.log(["Exception calling", verb, url, error]);
      throw error;
    }
  }
};

export default RightTimeApi;

